import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Opportunities from "@/pages/Opportunities";
import ProjectDetail from "@/pages/ProjectDetail";
import ForInvestors from "@/pages/ForInvestors";
import ForPartners from "@/pages/ForPartners";
import About from "@/pages/About";
import Technology from "@/pages/Technology";
import Contact from "@/pages/Contact";
import { PrivacyPolicy, Terms } from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const Shell = () => {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");

    useEffect(() => {
        if (isAdmin) return;
        if (window.matchMedia("(pointer: coarse)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, [isAdmin]);

    return (
        <>
            <ScrollToTop />
            {!isAdmin && <Header />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/opportunities" element={<Opportunities />} />
                <Route path="/opportunities/:slug" element={<ProjectDetail />} />
                <Route path="/for-investors" element={<ForInvestors />} />
                <Route path="/for-partners" element={<ForPartners />} />
                <Route path="/technology" element={<Technology />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Home />} />
            </Routes>
            {!isAdmin && <Footer />}
            {!isAdmin && <WhatsAppFloat />}
            <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0 } }} />
        </>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Shell />
        </BrowserRouter>
    );
}

export default App;
